<div>
    <twc-toggle labelPosition="left">
        <input twcToggleInput type="checkbox" [(ngModel)]="settings.localSettings.all" (ngModelChange)="save()" />
        <label twcToggleLabel translate>NOTIFICATION_PANEL.NOTIFY_ALL</label>
    </twc-toggle>
</div>

<h2 translate>NOTIFICATION_PANEL.PROJECTS_TITLE</h2>
<div>
    <twc-toggle labelPosition="left">
        <input twcToggleInput type="checkbox" [disabled]="settings.localSettings.all"
            [(ngModel)]="settings.localSettings.projects.CATALOG_VISIBILITY_GRANTED" (ngModelChange)="save()" />
        <label twcToggleLabel translate>NOTIFICATION_PANEL.NOTIFY_PROJECTS_GRANTED</label>
    </twc-toggle>
    <twc-toggle labelPosition="left">
        <input twcToggleInput type="checkbox" [disabled]="settings.localSettings.all"
            [(ngModel)]="settings.localSettings.projects.CATALOG_VISIBILITY_REVOKED" (ngModelChange)="save()" />
        <label twcToggleLabel translate>NOTIFICATION_PANEL.NOTIFY_PROJECTS_REVOKED</label>
    </twc-toggle>
    <twc-toggle labelPosition="left">
        <input twcToggleInput type="checkbox" [disabled]="settings.localSettings.all"
            [(ngModel)]="settings.localSettings.projects.CATALOG_OBJECT_UPDATE" (ngModelChange)="save()" />
        <label twcToggleLabel translate>NOTIFICATION_PANEL.NOTIFY_PROJECTS_UPDATE</label>
    </twc-toggle>
</div>

<h2 translate>NOTIFICATION_PANEL.LAYERS_TITLE</h2>
<div>
    <twc-toggle labelPosition="left">
        <input twcToggleInput type="checkbox" [disabled]="settings.localSettings.all"
            [(ngModel)]="settings.localSettings.layers.CATALOG_VISIBILITY_GRANTED" (ngModelChange)="save()" />
        <label twcToggleLabel translate>NOTIFICATION_PANEL.NOTIFY_LAYERS_GRANTED</label>
    </twc-toggle>

    <twc-toggle labelPosition="left">
        <input twcToggleInput type="checkbox" [disabled]="settings.localSettings.all"
            [(ngModel)]="settings.localSettings.layers.CATALOG_VISIBILITY_REVOKED" (ngModelChange)="save()" />
        <label twcToggleLabel translate>NOTIFICATION_PANEL.NOTIFY_LAYERS_REVOKED</label>
    </twc-toggle>

    <twc-toggle labelPosition="left">
        <input twcToggleInput type="checkbox" [disabled]="settings.localSettings.all"
            [(ngModel)]="settings.localSettings.layers.CATALOG_OBJECT_UPDATE" (ngModelChange)="save()" />
        <label twcToggleLabel translate>NOTIFICATION_PANEL.NOTIFY_LAYERS_UPDATE</label>
    </twc-toggle>

</div>

<h2>{{'NOTIFICATION_PANEL.JOB_SITES_TITLE' | translate}}</h2>
<div>
    <twc-toggle labelPosition="left">
        <input twcToggleInput type="checkbox" [disabled]="settings.localSettings.all"
            [(ngModel)]="settings.localSettings.sites.CATALOG_VISIBILITY_GRANTED" (ngModelChange)="save()" />
        <label twcToggleLabel>{{'NOTIFICATION_PANEL.NOTIFY_JOB_SITES_GRANTED' | translate}}</label>
    </twc-toggle>

    <twc-toggle labelPosition="left">
        <input twcToggleInput type="checkbox" [disabled]="settings.localSettings.all"
            [(ngModel)]="settings.localSettings.sites.CATALOG_VISIBILITY_REVOKED" (ngModelChange)="save()" />
        <label twcToggleLabel>{{'NOTIFICATION_PANEL.NOTIFY_JOB_SITES_REVOKED' | translate}}</label>
    </twc-toggle>

    <twc-toggle labelPosition="left">
        <input twcToggleInput type="checkbox" [disabled]="settings.localSettings.all"
            [(ngModel)]="settings.localSettings.sites.CATALOG_OBJECT_UPDATE" (ngModelChange)="save()" />
        <label twcToggleLabel>{{'NOTIFICATION_PANEL.NOTIFY_JOB_SITES_UPDATE' | translate}}</label>
    </twc-toggle>

</div>

<h2 translate>NOTIFICATION_PANEL.CATEGORIES_TITLE</h2>
<div>
    <twc-toggle labelPosition="left">
        <input twcToggleInput type="checkbox" [disabled]="settings.localSettings.all"
            [(ngModel)]="settings.localSettings.categories.CATALOG_VISIBILITY_GRANTED"
            (change)="changeCategories(settings.localSettings.categories.CATALOG_VISIBILITY_GRANTED)" />
        <label twcToggleLabel translate>NOTIFICATION_PANEL.NOTIFY_CATEGORIES</label>
    </twc-toggle>
</div>

<h2 translate>NOTIFICATION_PANEL.PROCESSES_TITLE</h2>
<div>
    <twc-toggle labelPosition="left">
        <input twcToggleInput type="checkbox" [(ngModel)]="settings.email.JOB_FINISHED"
            (ngModelChange)="saveEmailPreferences()" />
        <label twcToggleLabel translate>NOTIFICATION_PANEL.NOTIFY_EMAIL_JOB_FINISHED</label>
    </twc-toggle>

    <twc-toggle labelPosition="left">
        <input twcToggleInput type="checkbox" [disabled]="settings.localSettings.all"
            [(ngModel)]="settings.localSettings.layers.JOB_FINISHED" (ngModelChange)="save()" />
        <label twcToggleLabel translate>NOTIFICATION_PANEL.NOTIFY_JOB_FINISHED</label>
    </twc-toggle>
</div>

<h2 translate>NOTIFICATION_PANEL.QUOTAS_TITLE</h2>
<div>
    <twc-toggle labelPosition="left">
        <input twcToggleInput type="checkbox" [(ngModel)]="settings.email.QUOTA_EXCEEDED"
            (ngModelChange)="saveEmailPreferences()" />
        <label twcToggleLabel translate>NOTIFICATION_PANEL.NOTIFY_EMAIL_QUOTA_EXCEEDED</label>
    </twc-toggle>

    <twc-toggle *ngIf="isUserLoggedAdmin()" labelPosition="left">
        <input twcToggleInput type="checkbox" [disabled]="settings.localSettings.all"
            [(ngModel)]="settings.localSettings.QUOTA_EXCEEDED" (ngModelChange)="save()" />
        <label twcToggleLabel translate>NOTIFICATION_PANEL.NOTIFY_QUOTA_EXCEEDED</label>
    </twc-toggle>
</div>